<template>
  <div class="describe">
    <div class="column_1">
      <strong :listTitle="listTitle">{{listTitle}}</strong>
      <span class="twig"></span>
    </div>
    <div class="pro_1" :content="content" v-html="content">{{content}}</div>
  </div>
</template>

<script>
export default {
  name: 'Describe',
  props: {
    listTitle: {
      type: String,
      default () {
        return ''
      }
    },
    content: {
      type: String,
      default () {
        return ''
      }
    }
  }
}
</script>

<style scoped>
  .describe {
    padding: 0px 39px 0px 39px;
    background: #FFFFFF;
    width: 845px;
    float: right;
  }
  .column_1 {
    margin-top: 40px;
    height: 24px;
    line-height: 24px;
    font-size: 16px;
  }
  .pro_1 {
    padding: 25px 0px;
  }
  .twig {
    margin-top: 5px;
    width: 650px;
    height: 15px;
    background: #2F669A;
    float: right;
  }
  @media screen and (max-width:1200px) {
    .describe {
      width: 630px;
    }
    .twig {
      width: 445px;
    }
  }
  @media screen and (max-width:992px) {
    .describe {
      width: 530px;
    }
    .twig {
      width: 445px;
    }
  }
  @media screen and (max-width:768px) {
    .describe {
      width: 420px;
    }
    .twig {
      width: 240px;
    }
  }
</style>
